import BaseAPI from './base.api.service'

const resource = 'comments';
export default {
    async get(erid, params) {
        params = params || '';
        return await BaseAPI.get(`${resource}/${erid}${params}`);
    },
    //add
    async add(request) {
        return await BaseAPI.post(`${resource}/`, request)
    },
    //update
    //delete
}